export const searchPlaceholder = 'Pesquise por nome, conta ou CPF/CNPJ';
